// extracted by mini-css-extract-plugin
export default {"main":"dona_main__DoX8h","image":"dona_image__9Varn","box":"dona_box__FVSjJ","boxt":"dona_boxt__RDA2s","title":"dona_title__VwnPb"};